import { CREATE_QUOTE_DEAL_LIST_CLICKED } from '../actionTypes/recentDealsAnalyticsActionTypes';

// Analytics-only click event for "Create a Quote" in the Recent Deals slideout (dc-mv-325).
// Consumed by cdlV3AnalyticsMiddleware; carries no reducer state.
export const createQuoteDealListClicked = () => ({
    type: CREATE_QUOTE_DEAL_LIST_CLICKED
});
